import React, { useContext, useState } from "react";
import { AuthContext } from "../../common/Auth"
import { USERTYPES } from "../../constant/userType"
import DialogEditBanner from "../../components/hero-slider/bannerData/DialogEditBanner"

const NotFoundBanner = () => {
    const { bannersList, user, userType } = useContext(AuthContext)
    const adminUserId = user?.userId
    const [open, setOpen] = useState(false);
    const handleClose = () => {
        setOpen(false)
    }
    return (
        <>
            {(bannersList.length === undefined || bannersList.length === 0) && (<h1 className="text-center mb-35">No banner found</h1>)}

            {(((bannersList.length === undefined || bannersList.length === 0) && adminUserId) && (userType && userType !== USERTYPES.USER)) && (
                <div className="text-center mb-35">
                    <button onClick={() => { setOpen(true) }}>
                        Create Banner
                    </button>
                    <DialogEditBanner open={open} handleClose={handleClose} bannerId="" fromAction="FromHome" />
                </div>
            )}

        </>
    );
};

export default NotFoundBanner;
